import ResourceList from '../../resource/list';

const DevicesList = () => {

      return(
        <div>
          <ResourceList resource="devices" name="Devices"/>
        </div>
      )

}

export default DevicesList;
